import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { ChevronDown, Sorting } from '../ui/Icons';

export default function SortBy({
  sortBy,
}: componentTypes.SortByProps) {
  const { options, currentRefinement, refine } = sortBy;

  const selectedValue = options.filter((item) => item.value === currentRefinement) || [];

  return (
    <Popover className="filter-dropdown z-30 inline-block relative w-full lg:w-[20rem] data-[open]:active-dropdown">
      <PopoverButton className="dropdown-opener text-base px-4 py-4 leading-none gap-x-4 lg:gap-x-6 btn btn-outline-dark w-full">
        <span className="flex-1 0 flex items-center gap-x-2">
          <Sorting />
          {selectedValue[0].label}
        </span>
        <ChevronDown />
      </PopoverButton>
      <PopoverPanel className="absolute max-h-60 overflow-x-hidden overflow-y-auto bg-white top-full left-0 min-w-full w-auto max-w-max whitespace-nowrap py-1 lg:pr-6 gap-y-2.5 shadow-md rounded">
        {({ close }) => (
          <ul>
            {options.map((option) => (
              <li key={option.value} className="group">
                <button
                  type="button"
                  className={`w-full px-4 py-2 text-left text-base leading-normal underline decoration-1 decoration-transparent transition-all hover:decoration-current group-has-[.active]:text-accent ${option.value === currentRefinement ? 'active' : ''}`}
                  onClick={() => {
                    refine(option.value);
                    close();
                  }}
                >
                  {option.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </PopoverPanel>
    </Popover>
  );
}
